import React, { createContext, useContext, useMemo, PropsWithChildren, Context } from 'react';

import { PageProps } from '@vimeo/core/AppTypes';

import { IStoreInitialState } from '../../../types/store';

export interface ILiveGlobalsContext<T extends IStoreInitialState = IStoreInitialState> {
  initialState: T;
  pageProps: PageProps;
}

export const LiveGlobalsContext = createContext(null as unknown as ILiveGlobalsContext);

export function useLiveGlobals<
  T extends IStoreInitialState = Required<IStoreInitialState>,
>(): ILiveGlobalsContext<T> {
  return useContext(LiveGlobalsContext as unknown as Context<ILiveGlobalsContext<T>>);
}

export function LiveGlobalsProvider<T extends IStoreInitialState = IStoreInitialState>({
  initialState,
  children,
  pageProps,
}: PropsWithChildren<ILiveGlobalsContext<T>>) {
  const context: ILiveGlobalsContext = useMemo(
    () => ({ initialState, pageProps }),
    [initialState, pageProps],
  );

  return <LiveGlobalsContext.Provider value={context}>{children}</LiveGlobalsContext.Provider>;
}
